export default __webpack_public_path__ + "static/media/insta.3856b08a.png";